import { Blueprint, BlueprintPreview } from 'dashboard/models/blueprint';
import Action from 'lib/interfaces/Action';

export type BlueprintsActions =
  | Action<BlueprintsActionType.SetBlueprints, SetBlueprintsPayload>
  | Action<BlueprintsActionType.AddBlueprints, AddBlueprintsPayload>
  | Action<BlueprintsActionType.SetBlueprintPreview, SetBluperintPreviewPayload>;

export enum BlueprintsActionType {
  SetBlueprints = 'blueprint/SET_BLUEPRINTS',
  AddBlueprints = 'blueprint/ADD_BLUEPRINTS',
  SetBlueprintPreview = 'blueprint/SET_BLUEPRINT_PREVIEW',
}

interface SetBlueprintsPayload {
  blueprints: Blueprint[];
}

export function setBlueprints(
  blueprints: Blueprint[],
): Action<BlueprintsActionType.SetBlueprints, SetBlueprintsPayload> {
  return {
    payload: {
      blueprints,
    },
    type: BlueprintsActionType.SetBlueprints,
  };
}

interface AddBlueprintsPayload {
  blueprints: Blueprint[];
}

export function addBlueprints(
  blueprints: Blueprint[],
): Action<BlueprintsActionType.AddBlueprints, AddBlueprintsPayload> {
  return {
    payload: {
      blueprints,
    },
    type: BlueprintsActionType.AddBlueprints,
  };
}

interface SetBluperintPreviewPayload {
  blueprintKey: string;
  preview: BlueprintPreview;
}

export function setBlueprintPreview(
  blueprintKey: string,
  preview: BlueprintPreview,
): Action<BlueprintsActionType.SetBlueprintPreview, SetBluperintPreviewPayload> {
  return {
    payload: {
      blueprintKey,
      preview,
    },
    type: BlueprintsActionType.SetBlueprintPreview,
  };
}
